import { clsx } from 'clsx';
import type { Hashtag } from '../api/client';

interface TopHashtagsProps {
  hashtags: Hashtag[];
}

const typeColors: Record<string, string> = {
  customer: 'bg-blue-100 text-blue-700',
  product: 'bg-purple-100 text-purple-700',
  engagement: 'bg-green-100 text-green-700',
  uncategorized: 'bg-gray-100 text-gray-600',
};

export default function TopHashtags({ hashtags }: TopHashtagsProps) {
  const sortedHashtags = [...hashtags]
    .sort((a, b) => b.usage_count - a.usage_count)
    .slice(0, 10);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Top Hashtags</h2>

      {sortedHashtags.length === 0 ? (
        <p className="text-gray-500 text-sm">No hashtags yet</p>
      ) : (
        <div className="space-y-3">
          {sortedHashtags.map((hashtag) => (
            <div key={hashtag.id} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span
                  className={clsx(
                    'px-2 py-1 rounded text-xs font-medium',
                    typeColors[hashtag.type]
                  )}
                >
                  {hashtag.type}
                </span>
                <span className="text-sm font-medium text-gray-700">
                  #{hashtag.name}
                </span>
              </div>
              <span className="text-sm text-gray-500">
                {hashtag.usage_count} uses
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
